import React, { ReactNode, Suspense } from "react";
import styled from "styled-components/macro";
import { MenuLeftSide } from "../MenuLeftSide";
import { LoaderCustom } from "../Loader";
import { theme } from "../../styles/theme";

const Root = styled.div<{ $visible: boolean }>`
  background: white;
  display: ${(p) => (p.$visible ? "flex" : "none")};
`;
const NavigationContainer = styled.div``;
const Content = styled.div`
  flex-grow: 1;
  position: relative;
`;

export const LayoutWithLeftMenu: React.FC<{
  children: ReactNode;
  visible?: boolean;
}> = ({ children, visible = true }) => {
  return (
    <Root $visible={visible}>
      <NavigationContainer>
        <MenuLeftSide />
      </NavigationContainer>
      <Content>
        <Suspense
          fallback={
            <LoaderCustom
              size={5}
              color={theme.colors.bgBody}
              text=""
              whiteBackground={true}
            />
          }
        >
          {children}
        </Suspense>
      </Content>
    </Root>
  );
};
